import { render, staticRenderFns } from "./category-color-bar.vue?vue&type=template&id=c81f3850&scoped=true&"
import script from "./category-color-bar.vue?vue&type=script&lang=ts&"
export * from "./category-color-bar.vue?vue&type=script&lang=ts&"
import style0 from "./category-color-bar.vue?vue&type=style&index=0&id=c81f3850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81f3850",
  null
  
)

export default component.exports